import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { isNil } from 'ramda';

import { isAgency, isBroker, isHomeowner } from './agent';

/**
 * Проверяем, что агент не является саб агентом
 * а просто указал у себя в профиле агентство (сервер не дает явно это понять)
 * @param agent IAgentSchema
 * @param offer IOfferSchema
 */
export function isFakeSubAgent(agent: IAgentSchema, offer: IOfferSchema) {
  return (
    !agent.isSubAgent &&
    !isNil(agent.companyName) &&
    !isAgency(agent) &&
    !isBroker(agent) &&
    !isHomeowner(offer) &&
    !agent.isDeveloper
  );
}
